<template>
  <div class="assetView h-full">
    <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
      <el-row type="flex" :gutter="20">
        <el-col>
          <div style="height: 40vh">
            <el-tabs type="border-card" class="object-tabs" id="baseInfo">
              <el-tab-pane>
                <span slot="label" v-if="!isFullScreen">
                  <i
                    @click="fullScreen('baseInfo')"
                    class="iconfont icon-line-fullscreen relation-fullScreen cur-pointer position-absolute"
                  ></i>
                  基本信息
                </span>
                <span slot="label" v-else>
                  <i
                    @click="exitFullScreen()"
                    class="iconfont icon-line-fullscreen cur-pointer relation-fullScreen position-absolute"
                  ></i>
                  基本信息
                </span>
                <el-form label-width="130px">
                  <el-form-item
                    :label="val.name"
                    v-for="(val, index) in baseAttribute.headers"
                    :key="index"
                  >
                    <el-input :value="baseAttribute.dynamicData[val.code]" readonly>
                      <el-button
                        slot="append"
                        size="small"
                        class="iconfont icon-search"
                        v-if="
                          [...imgExt, ...fileExt, 'pdf'].includes(
                            _.split(baseAttribute.dynamicData[val.code], '.')[1]
                          )
                        "
                        @click="viewBasicFile(baseAttribute.dynamicData[val.code])"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col>
          <div style="height: 40vh">
            <div class="relative-box mb-10px" id="relation">
              <h5 class="flex-row-between">
                <span class="fz-14 ml-10px">关联关系</span>
                <i
                  @click="fullScreen('relation')"
                  v-show="!isFullScreen"
                  class="iconfont icon-line-fullscreen relation-fullScreen cur-pointer position-absolute"
                ></i>
                <i
                  @click="exitFullScreen()"
                  id="iconExitFull"
                  v-show="isFullScreen"
                  class="iconfont icon-line-fullscreen cur-pointer relation-fullScreen position-absolute"
                ></i>
                <el-button type="primary" @click="back" id="backbtn" size="mini" class="float-right"
                  >返回</el-button
                >
              </h5>
              <div id="mynetwork"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="table-list">
        <el-tabs type="border-card" v-model="currentTabIndex">
          <el-tab-pane
            :label="val.className"
            :name="String(index)"
            v-for="(val, index) in tableLists"
            :key="index"
            class="h-full"
          >
            <div class="table-search">
              <el-select
                filterable
                style="width: 200px"
                clearable
                class="mr-10px"
                v-model="attrId"
                @change="changeAttr(attrId)"
                placeholder="代码"
              >
                <el-option
                  v-for="item in codeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.columnName"
                ></el-option>
              </el-select>
              <el-select
                size="small"
                clearable
                filterable
                v-model="symbolValue"
                v-if="selectedAttrType !== 11"
                placeholder="请选择"
                class="mr-10px"
                style="width: 100px"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                style="width: 200px"
                size="small"
                v-model.trim="tableParams.keyword"
                placeholder="请输入关键字"
                v-if="selectedAttrType === 1"
                clearable
              >
              </el-input>
              <el-select
                size="small"
                clearable
                v-if="selectedAttrType === 11"
                filterable
                v-model="tableParams.keyword"
                placeholder="请选择"
                class="mr-10px"
                style="width: 200px"
              >
                <el-option
                  v-for="item in labelArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
              <el-input-number
                v-else-if="selectedAttrType === 2 || selectedAttrType === 3"
                v-model.trim="tableParams.keyword"
                :controls="false"
                class="inputNumber"
                style="width: 200px; height: 32px"
              >
              </el-input-number>
              <el-time-picker
                v-else-if="selectedAttrType === 9"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                value-format="HH:mm:ss"
                placeholder="选择时间"
              >
              </el-time-picker>
              <el-date-picker
                v-else-if="selectedAttrType === 8"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-date-picker
                v-else-if="selectedAttrType === 6"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              ></el-date-picker>
              <div class="ml-10px">
                <el-button
                  size="small"
                  class="ml-0px mr-5px"
                  type="primary"
                  @click="getTableData('refresh')"
                  >搜索</el-button
                >
              </div>
            </div>
            <el-table
              :data="tableDatas.dynamicData"
              border
              height="calc(100% - 80px)"
              v-loading="isLoadTable"
              @row-dblclick="dbClickOpr"
            >
              <el-table-column
                :prop="val.code"
                :label="val.name"
                v-for="(val, index) in tableDatas.headers"
                :key="index"
                min-width="150"
              >
                <template slot-scope="scope">
                  {{ scope.row[val.code] }}
                  <el-tooltip
                    content="上传"
                    v-if="computeOperateButton('上传', val.name, '上传文件')"
                  >
                    <el-button
                      class="iconfont icon-line-upload"
                      @click="uploadFile(scope.row, val.code)"
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    content="查看"
                    v-if="computeOperateButton('查看', val.name, '打开文件')"
                  >
                    <el-button
                      class="iconfont icon-line-show"
                      type="primary"
                      size="mini"
                      @click="viewFile(scope.row, val.code)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    content="下载"
                    v-if="computeOperateButton('下载', val.name, '下载文件')"
                  >
                    <el-button
                      class="iconfont icon-line-download"
                      size="mini"
                      @click="downloadFile(scope.row, val.code)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="getTableData('refresh')"
              @current-change="getTableData"
              :current-page.sync="tableParams.pageNo"
              :page-sizes="[5, 10, 15, 30]"
              :page-size.sync="tableParams.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="pageTotal"
              class="pagination-box"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 上传start -->
    <el-dialog
      id="viewDialog"
      :width="dialogTitle === '上传' ? '500px' : '1200px'"
      :title="dialogTitle"
      :top="isFullScreen ? '0' : '15vh'"
      :visible.sync="dialogVisible"
      ref="viewDialog"
    >
      <i
        @click="fullScreen('viewDialog')"
        v-if="!isFullScreen && dialogTitle !== '上传'"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        @click="exitFullScreen()"
        v-if="isFullScreen && dialogTitle !== '上传'"
        class="iconfont icon-pc_merge cur-pointer position-absolute"
      ></i>
      <el-upload
        v-if="dialogTitle === '上传'"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        class="flex"
        style="justify-content: center"
        :multiple="false"
      >
        <i style="font-size: 67px" class="el-icon-upload"></i>
        <div class="el-upload__text">
          一次只能上传一个文件，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <div style="height: 600px" id="fileView" v-else>
        <img
          :src="viewUrl"
          class="w-full h-full"
          v-if="_.includes(imgExt, _.split(viewUrl, '.')[_.split(viewUrl, '.').length - 1])"
        />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
    <!-- 上传end -->
  </div>
</template>

<script>
import vis from 'vis'
import assetService from '@/services/assetService'
import StdAttrBusinessOperation from '@/services/bsApi/StdAttributeBusinessOperation'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import StdBusinessOperation from '@/services/bsApi/StdBusinessOperation'

export default {
  data() {
    return {
      selectedAttrType: 1,
      symbolList: [
        { value: '=', name: '等于' },
        { value: '$ne', name: '不等于' },
        { value: '$gt', name: '大于' },
        { value: '$gte', name: '大于等于' },
        { value: '$lt', name: '小于' },
        { value: '$lte', name: '小于等于' },
        { value: '$text', name: '包含' },
        { value: '$ntext', name: '不包含' },
        { value: '$in', name: '在范围内' },
        { value: '$nin', name: '不在范围内' },
      ],
      symbolValue: '',
      attrId: '',
      attrList: [],
      labelArr: [],
      isFullScreen: false,
      currentCode: '',
      currentConfigData: [],
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      currentEditType: 'upload',
      viewUrl: '',
      dialogTitle: '上传',
      currentRow: null,
      file: null,
      dialogVisible: false,
      code: '',
      input: '',
      codeOptions: [],
      queryParam: {
        id: this.$route.query.id,
        classId: this.$route.query.classId,
      },
      baseAttribute: {}, // 基本属性数据
      tableDatas: {}, // tab切换下面的表格数据对象
      tableLists: [], // tab表格种类集合
      tableParams: {
        pageNo: 1,
        pageSize: 15,
        keyword: '',
      },
      pageTotal: 0,
      currentTabIndex: '0', // 当前tab索引
      nodesData: [], // 关联关系节点数据集合
      edgesData: [], // 关联关系边界线数据集合
      isLoadTable: false, // 底部动态表格加载状态
      timer: null,
      currentTabRow: null,
      currentOperateAttrRow: null,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  async created() {
    await this.initDraw()
    await this.getBaseAttribute()
    await this.getTableList()
    await this.getCodeList()
    await this.getTableData('refresh')
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    async currentTabIndex(val) {
      this.tableParams = {
        pageNo: 1,
        pageSize: 15,
        keyword: '',
      }
      this.currentEditType = ''
      this.attrId = ''
      this.symbolValue = ''
      this.codeOptions = []
      const currentRow = this.tableLists[_.toNumber(val)]
      this.currentTabRow = currentRow
      this.findAttrConfig(currentRow.classId)
      clearInterval(this.timer)
      this.getCodeList()
    },
    dialogVisible(val) {
      if (!val && this.isFullScreen) {
        this.$nextTick(() => {
          this.exitFullScreen()
        })
      }
    },
    attrId(val) {
      this.tableParams.keyword = ''
      this.symbolValue = ''
      if (val) {
        this.getTableData('refresh')
      }
    },
  },
  mounted() {
    const that = this
    window.onresize = function() {
      if (!that.checkFull()) {
        // 退出全屏后要执行的动作
        that.exitFullScreen()
      }
    }
  },
  methods: {
    async changeAttr(value) {
      if (!value) {
        return
      }
      this.keyword = ''
      this.codeOptions.forEach((item) => {
        if (item.columnName === value) {
          this.selectedAttrType = item.valueType
        }
      })
      if (this.selectedAttrType === 11) {
        const parameter = {
          classId: this.classId,
        }
        const res = await stdClassDataService.getTagAttrList(parameter)
        if (res && res.code === 0 && res.data) {
          this.labelArr = res.data
        }
      }
    },
    checkFull() {
      // 判断浏览器是否处于全屏状态 (需要考虑兼容问题)
      // 火狐浏览器
      let isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        // 谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled
      if (isFull === undefined) {
        isFull = false
      }
      return isFull
    },
    fullScreen(dom) {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById(dom))
      document.getElementById('backbtn').style.display = 'none'
      $('.relative-box').css('background-color', '#fff')
      if (dom === 'baseInfo') {
        $('.el-tabs__content').css('height', '100vh')
      }
      document.getElementById('iconExitFull').style.right = '20px'
    },
    exitFullScreen() {
      this.isFullScreen = false
      document.getElementById('backbtn').style.display = 'block'
      this.exitFullscreen()
      $('.el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
      $('.el-tabs__content').css('height', '35vh')
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('.el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    computeOperateButton(type, columnName, operateName) {
      let showBtn = false
      _.forEach(this.currentConfigData, (item) => {
        if (item.attributeName === columnName && item.businessOperationName === operateName) {
          showBtn = true
          return false
        }
      })
      return showBtn
    },
    async uploadExcel() {
      const formData = new FormData()
      _.forIn({ file: this.file }, (value, key) => {
        formData.append(key, value)
      })
      const fileType = _.split(this.file.name, '.')[1]
      if (_.includes(this.fileExt, fileType) && fileType !== 'pdf') {
        formData.append('type', 1)
      } else {
        formData.append('type', 0)
      }
      const res = await assetService.uploadFile({
        reqData: formData,
      })
      if (res && res.code === 0 && res.data) {
        this.$message.success('上传成功')
        this.saveFile(res.data[0].source)
        this.dialogVisible = false
      }
    },
    async saveFile(source) {
      const res = await assetService.updateAttrData({
        dataId: this.currentRow.id,
        attributeList: [
          {
            value: source,
            classId: this.currentTabRow.classId,
            columnName: this.currentCode,
          },
        ],
      })
      if (res && res.code === 0) {
        // 上传成功刷新列表
        this.getCodeList()
      }
    },
    getFileContent(file) {
      this.file = file
    },
    uploadFile(row, code) {
      this.currentCode = code
      this.dialogTitle = '上传'
      this.currentRow = row
      this.dialogVisible = true
      $('.el-dialog')
        .width(600)
        .height(300)
    },
    async downloadFile(row, columnName) {
      const res = await assetService.findAttrData({
        classId: this.currentTabRow.classId,
        dataId: row.id,
        columnName,
      })
      if (res && res.code === 0 && res.data) {
        const currentRow = _.find(res.data.attributeList, ['columnName', columnName])
        const index = currentRow.value.lastIndexOf('.')
        const fileName = currentRow.value.slice(0, index)
        const fileType = currentRow.value.slice(index + 1, currentRow.value.length)
        if (![...this.imgExt, ...this.fileExt, 'pdf'].includes(fileType)) {
          this.$message.warning('未上传文件')
          return
        }
        const url = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
        window.location.href = url
      }
    },
    viewBasicFile(fileName) {
      this.dialogTitle = '查看'
      if (this.imgExt.includes(_.split(fileName, '.')[1]) || fileName.includes('pdf')) {
        this.viewUrl = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=0&type=0&target=${fileName}`
      } else {
        this.viewUrl = `${
          this.currentEnv.VUE_APP_UPLOAD_SERVER
        }/api/Common/file?downloadType=0&type=1&target=${_.split(fileName, '.')[0]}`
      }
      this.dialogVisible = true
    },
    async viewFile(row, columnName) {
      this.dialogTitle = '查看'
      $('.el-dialog')
        .width(1200)
        .height(700)
      const res = await assetService.findAttrData({
        classId: this.currentTabRow.classId,
        dataId: row.id,
        columnName,
      })
      if (res && res.code === 0 && res.data) {
        const currentRow = _.find(res.data.attributeList, ['columnName', columnName])
        if (![...this.imgExt, ...this.fileExt, 'pdf'].includes(_.split(currentRow.value, '.')[1])) {
          this.$message.warning('未上传文件')
          return
        }
        if (
          this.imgExt.includes(_.split(currentRow.value, '.')[1]) ||
          currentRow.value.includes('pdf')
        ) {
          this.viewUrl = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=0&type=0&target=${currentRow.value}`
        } else {
          this.viewUrl = `${
            this.currentEnv.VUE_APP_UPLOAD_SERVER
          }/api/Common/file?downloadType=0&type=1&target=${_.split(currentRow.value, '.')[0]}`
        }
        this.dialogVisible = true
      }
    },
    async findOperateType(name, item) {
      // 获取操作类型
      const res = await StdBusinessOperation.find({
        name: {
          $text: name,
        },
      })
      if (res && res.code === 0 && res.data) {
        switch (res.data[0].responder) {
          // 通过responder判断操作类型
          case 'GetRealData': // 获取实时数据
            this.timer = setInterval(() => {
              if (item.parameterList[0].parameterType === 0) {
                // 固定值
                this.findRealTimeData(0, item.parameterList[0].fixedValue, item.attributeName)
              } else {
                // 选择属性
                this.findRealTimeData(1, item.parameterList[0].attributeName, item.attributeName)
              }
            }, 5000)
            break
          case 'xxx/openfile': // 打开文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'view'
            break
          case 'xxx/uploadfile': // 上传文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'upload'
            break
          default:
            // 下载文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'download'
            break
        }
      }
    },
    async findAttrConfig(classId) {
      const res = await StdAttrBusinessOperation.find({
        pageNo: 1,
        pageSize: 999,
        class_id: classId,
      })
      if (res && res.code === 0 && res.data) {
        this.currentConfigData = res.data
        _.forEach(res.data, (item) => {
          this.findOperateType(item.businessOperationName, item)
        })
      }
    },
    async findRealTimeData(type, chooseAttrName, attrName) {
      let attrCode
      if (type === 1) {
        // 选择属性
        attrCode = _.find(this.tableDatas.headers, ['name', chooseAttrName])
      }
      const unitCode = _.find(this.tableDatas.headers, ['name', attrName])
      const codes =
        type === 0
          ? chooseAttrName
          : _.map(this.tableDatas.dynamicData, (item) => {
              return item[attrCode.code]
            }).join(',')
      if (_.isEmpty(codes)) {
        clearInterval(this.timer)
        return
      }
      const res = await assetService.getWizData({
        pointIds: '',
        codes:
          type === 0
            ? chooseAttrName
            : _.map(this.tableDatas.dynamicData, (item) => {
                return item[attrCode.code]
              }).join(','),
      })
      if (res && res.code === 0 && res.data) {
        _.forEach(this.tableDatas.dynamicData, (item) => {
          const currentRow = _.find(res.data, ['code', item[attrCode.code]])
          this.$set(item, unitCode.code, currentRow.value)
        })
      }
    },
    async dbClickOpr(val) {
      const obj = this.tableLists[Number(this.currentTabIndex)]
      const res = await assetService.addClassRelation({
        classid: obj.classId,
        id: val.id,
        joinclassid: obj.joinClassId,
        dataid: obj.dataId,
        referencetype: obj.referenceType,
      })
      if (res && res.code === 0 && res.data) {
        // 去重
        let flag = false
        _.forEach(this.nodesData, (item) => {
          if (item.id === res.data.objNodes[0].id) {
            flag = true
          }
        })
        if (!flag) {
          this.nodesData.push(res.data.objNodes[0])
          this.edgesData.push(res.data.edges[0])
          this.initSetting()
        }
      }
    },
    // 获取代码下拉集合
    async getCodeList() {
      if (!this.tableLists.length) {
        return
      }
      const res = await stdClassDataService.getInsertData({
        classId: this.tableLists[Number(this.currentTabIndex)]
          ? this.tableLists[Number(this.currentTabIndex)].classId
          : '',
      })
      if (res && res.code === 0 && res.data) {
        this.codeOptions = res.data.attributeList
        if (this.codeOptions.length) {
          this.attrId = this.codeOptions[0].columnName
          this.selectedAttrType = this.codeOptions[0].valueType
        }
      }
    },
    // 获取基本属性
    async getBaseAttribute() {
      const res = await assetService.getDatabaseAttribute(this.queryParam)
      if (res && res.code === 0) {
        this.baseAttribute = res.data
      }
    },
    // 获取table表格种类集合
    async getTableList() {
      this.queryParam.breakdownid = ''
      const res = await assetService.getAssetsTableList(this.queryParam)
      if (res && res.code === 0 && res.data) {
        this.tableLists = res.data
      }
    },
    // 获取动态关联表数据
    async getTableData(type) {
      if (!this.tableLists.length) {
        return
      }
      if (!this.attrId && type === 'refresh') {
        this.$message.warning('请先选择代码')
        return
      }
      this.isLoadTable = true
      if (type === 'refresh') {
        this.tableParams.pageNo = 1
      }
      // 当属性类行为标签类型（11），需要额外的参数
      if (this.selectedAttrType !== 11 && (this.symbolValue === '=' || this.symbolValue === '')) {
        this.tableParams[this.attrId] = this.tableParams.keyword
      } else if (
        this.selectedAttrType !== 11 &&
        (this.symbolValue !== '=' || this.symbolValue !== '')
      ) {
        const obj = {}
        obj[this.symbolValue] = this.tableParams.keyword
        this.tableParams[this.attrId] = obj
      } else {
        this.tableParams.tagcolumn = this.attrId
        this.tableParams.tagvalue = `${this.tableParams.keyword},`
      }
      const params = _.assign({}, this.tableParams, this.tableLists[Number(this.currentTabIndex)])
      const res = await assetService.getAssetsTableData(params)
      if (res && res.code === 0) {
        this.tableDatas = res.data
        this.pageTotal = res.page.recordCount
        this.isLoadTable = false
      } else {
        this.isLoadTable = false
      }
    },
    // 初始化关联关系图
    initDraw() {
      this.$nextTick(async () => {
        const resNodes = await assetService.getRelationData(this.queryParam)
        if (resNodes && resNodes.code === 0) {
          this.nodesData = resNodes.data.objNodes
          this.edgesData = resNodes.data.edges
        }
        this.initSetting()
      })
    },
    // 初始化关系图的配置
    initSetting() {
      // create an array with nodes
      const nodes = new vis.DataSet(this.nodesData)

      // create an array with edges
      const edges = new vis.DataSet(this.edgesData)

      // create a network
      const container = document.getElementById('mynetwork')
      // provide the data in the vis format
      const data = {
        nodes,
        edges,
      }
      const options = {
        edges: {
          // 连接线的样式
          font: {
            size: 12,
          },
          widthConstraint: {
            maximum: 40,
          },
          length: 200,
          smooth: {
            // 设置两个节点之前的连线的状态
            enabled: false, // 默认是true，设置为false之后，两个节点之前的连线始终为直线，不会出现贝塞尔曲线
          },
          arrows: { to: true }, // 箭头指向to
        },
        nodes: {
          shape: 'circle', // 节点的外观。为circle时label显示在节点内，为dot时label显示在节点下方
          size: 60, // 节点的大小
          font: {
            color: 'white', // 字体的颜色
            size: 12, // 显示字体大小
            align: 'center',
          },
          borderWidth: 1, // 节点边框宽度，单位为px
          borderWidthSelected: 3, // 节点被选中时边框的宽度，单位为px
          labelHighlightBold: false, // 确定选择节点时标签是否变为粗体
          color: {
            border: '#2B7Ca9', // 节点边框颜色
            background: '#2B7CE9', // 节点背景颜色
            highlight: {
              // 节点选中时状态颜色
              background: '#2B7CE9',
            },
            // hover: {
            //   //节点鼠标滑过时状态颜色
            //   background: '#fff',
            // },
          },
          shapeProperties: {
            useBorderWithImage: true,
          },
        },
        physics: {
          // 物理引擎-计算节点之前斥力，进行自动排列的属性
          stabilization: false,
          barnesHut: {
            centralGravity: 0.3,
            springLength: 60,
            gravitationalConstant: -40000,
            avoidOverlap: 0.8,
            damping: 0.09,
            springConstant: 0.5,
          },
          minVelocity: 16,
          // manipulation: { enabled: false },
          enabled: true, // 默认是true，设置为false后，节点将不会自动改变，拖动谁谁动。不影响其他的节点
        },
      }

      // initialize your network!
      const network = new vis.Network(container, data, options)
      network.on('selectNode', async (clickData) => {
        this.currentTabIndex = '0'
        const arr = clickData.nodes[0].split(',')
        this.queryParam.classId = arr[0]
        this.queryParam.id = arr[1]
        this.tableParams = {
          pageNo: 1,
          pageSize: 15,
          keyword: '',
        }
        await this.getBaseAttribute()
        await this.getTableList()
        await this.getCodeList()
        await this.getTableData('refresh')
      })
    },
    // 返回操作
    back() {
      this.$router.push({
        path: './data-retrieval',
        query: {
          form: 'detail',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped type="text/scss">

@import '~vis/dist/vis.css';
/deep/.vis-tooltip {
  width: 300px !important;
  white-space: pre-wrap !important;
}
.icon-line-fullscreen {
  top: 23px;
  right: 45px;
}
.position-absolute {
  position: absolute;
}
.relation-fullScreen {
  top: 0px;
  right: 80px;
}
.relative-box {
  border: 1px solid lightgray;
  height: 97%;
  h5 {
    background-color: rgba(177, 176, 176, 0.151);
    height: 35px;
    line-height: 35px;
  }
  #mynetwork {
    width: 100%;
    height: 90%;
  }
}
.table-list {
  position: relative;
  /deep/.el-input__suffix-inner {
    display: inline-block;
    margin-top: -4px;
  }
  /deep/.el-tabs__nav-next,
  /deep/.el-tabs__nav-prev {
    line-height: 34px !important;
    font-size: 20px;
    color: #1682e6;
  }
  /deep/.el-tabs__content {
    height: calc(60vh - 185px) !important;
    position: relative;
    .el-table__body-wrapper {
      height: calc(60vh - 365px) !important;
      overflow-y: auto !important;
    }
    .pagination-box {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }
  .table-search {
    height: 30px;
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-bottom: 20px;
    /deep/.el-input__inner {
      height: 30px;
    }
    /deep/.el-input__suffix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.object-tabs {
  /deep/.el-tabs__content {
    height: 35vh;
    overflow-y: auto;
    .el-form-item__label {
      text-align: right;
    }
  }
  /deep/.el-form-item__content {
    margin-left: 140px !important;
  }
}
.el-tabs--border-card {
  background: #ffffff !important;
}
/deep/.el-input__inner {
  height: 32px !important;
}
/deep/.el-input__icon {
  line-height: 32px;
}
.inputNumber {
  line-height: 32px !important;
}

</style>
